<template>
    <div class="main-container">
        <div class="head-container">
            <div class="form-label">
                <span>名  称：</span>
            </div>
            <div class="form-input">
                <Select v-model="formParam.type" filterable clearable>
                    <Option v-for="item in settingType" :value="item.dictValue" :key="item.dictValue">{{ item.dictName }}</Option>
                </Select>
            </div>
            <div class="form-button">
                <Button type="primary" icon="md-search" style="margin-right: 10px" @click="onQuery">查询</Button>
            </div>
        </div>
        <div class="button-container">
            <Button type="primary" icon="md-add" style="margin-right: 20px" @click="showModal">添加设置</Button>
        </div>
        <div class="table-container">
            <Table :columns="columns" :data="tableData">
                <template #action="{ row, index }">
                    <Button class="table-button-edit" size="small" style="margin-right: 5px" @click="edit(row)">编辑</Button>
                    <Poptip
                        confirm
                        title="确定删除?"
                        @on-ok="remove(row)" placement="top-start" transfer>
                        <Button class="table-button-remove" size="small">删除</Button>
                    </Poptip>
                </template>
            </Table>
            <div style="margin-top: 10px;text-align: right">
                <Page v-model="formParam.current" :page-size="formParam.size"
                      :total="formParam.total"
                      @on-change="onPageChange"
                      @on-page-size-change="onPageSizeChange"
                      show-sizer show-elevator show-total/>
            </div>
        </div>
        <Modal
            v-model="modal"
            title="新增设置"
            footer-hide>
            <div>
                <Form :model="formItem" :label-width="80" ref="formItem" :rules="rules">
                    <FormItem label="设置类型" prop="type">
                        <Select v-model="formItem.type" filterable clearable>
                            <Option v-for="item in settingType" :value="item.dictValue" :key="item.dictValue">
                                {{ item.dictName }}
                            </Option>
                        </Select>
                    </FormItem>
                    <FormItem label="内容" prop="content">
                        <Input type="textarea" v-model="formItem.content" placeholder="请输入内容"></Input>
                    </FormItem>
                </Form>
                <div slot="footer" style="text-align: right">
                    <Button style="margin-right: 10px" type="primary" :loading="loading" @click="handleOk">确定</Button>
                    <Button @click="handleCancel">取消</Button>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import {saveStoreSetting, queryStoreSettingPage, removeStoreSetting} from "@/api/baseData"
import {queryDictList} from "@/api"

export default {
    name: "StoreSetting",
    data() {
        return {
            settingType: [],
            formParam: {
                type: '',
                total: 0,
                current: 1,
                size: 10,
            },
            formItem: {
                type: '',
                content: '',
            },
            modal: false,
            loading: false,
            rules: {
                type: [
                    {required: true, message: '请选择设置类型', trigger: 'change'},
                ],
                content: [
                    {required: true, message: '设置内容不能为空', trigger: 'blur'},
                ],
            },
            columns: [
                {
                    title: '设置类型',
                    key: 'type',
                    align: 'left',
                    width: 120,
                    render: this.renderType,
                },
                {
                    title: '内容',
                    key: 'content',
                    align: 'center',
                },
                {
                    title: '更新时间',
                    key: 'updateTime',
                    align: 'center',
                    width: 180,
                },
                {
                    title: '操作',
                    slot: 'action',
                    width: 160,
                    align: 'center',
                },
            ],
            tableData: [],
        }
    },
    mounted() {
        this.initInfo()
    },
    methods: {
        async initInfo() {
            let {data} = await queryDictList({classCode: 'store_type'})
            this.settingType = data
            await this.onQuery()
        },
        async onQuery() {
            let res = await queryStoreSettingPage(this.formParam)
            if (res.data != null) {
                this.tableData = res.data
                this.formParam.current = res.current
                this.formParam.total = res.total
            }
        },
        showModal() {
            this.formItem = {
                type: '',
                content: '',
            }
            this.modal = true
        },
        handleOk() {
            this.loading = true
            this.$refs.formItem.validate(async (valid) => {
                if (valid) {
                    await saveStoreSetting(this.formItem)
                    this.loading = false
                    this.modal = false
                    this.onQuery()
                } else {
                    this.loading = false
                }
            })
        },
        handleCancel() {
            this.modal = false
        },
        edit(row) {
            this.formItem = Object.assign({}, row)
            this.modal = true
        },
        async remove(row) {
            await removeStoreSetting(row)
            await this.onQuery()
        },
        onPageChange(e) {
            this.formParam.current = e
            this.onQuery()
        },
        onPageSizeChange(e) {
            this.formParam.current = 1
            this.formParam.size = e
            this.onQuery()
        },
        renderType(h, param) {
            let type = param.row.type
            for (let dict of this.settingType) {
                if (dict.dictValue == type) {
                    return h('span', dict.dictName)
                }
            }
        },
    },
}
</script>

<style scoped>
.form-label {
    display: inline-block;
    font-weight: bold;
    margin-left: 10px;
}

.form-input {
    display: inline-block;
    width: 400px;
    margin-right: 15px;
}

.head-container {
    margin: 10px;
    background: #fafafa;
    padding: 10px;
}

.button-container {
    margin: 10px;
    background: #fafafa;
    padding: 10px;
}

.form-button {
    display: inline-block;
}

.table-container {
    margin: 10px;
}
</style>
